const salesforceFields = {
  EMAIL: 'Email',
  EXPRESS_WRITTEN_CONSENT: 'Express_written_consent__c',
  LAST_NAME: 'LastName',
  WHATSAPP_CONSENT_M: 'whatsapp_consent__m',
};

export default salesforceFields;
